import type { BaseEntity } from './BaseEntity';
import type { ConsumedInventoryItem } from "./ConsumedInventoryItem";
import type { Item } from './Item';
import type { PurchaseOrder } from './PurchaseOrder';
import type { Vendor } from './Vendor';
import type { Document } from './Document';
import { Dayjs } from 'dayjs';

export interface InventoryItem extends BaseEntity {
  quantityOnHand?: number;
  costPerUnit: number;
  quantityOrdered: number;
  isArchived: boolean;
  itemId: number;
  item?: Item;
  vendorId: number;
  vendor?: Vendor;
  purchaseOrderId: number;
  purchaseOrder?: PurchaseOrder;
  consumedInventoryItems?: ConsumedInventoryItem[];
  attachments?: Document[];
  updatedAttachments?: FileList;
  remainingQuantityOnHand?: number;
  lotNumber?: string;
  surchargePerUnit?: number;
  shippingCostPerUnit?: number;
  surchargeOrDiscount?: number;
  totalCostPerUnit?: number;
  totalOrderedCost?: number;
  orderDetails?: string;
  dateOrdered?: Dayjs;
}

type ValidationResult = { issues: { message: string; path: (keyof InventoryItem)[] }[] };

export function validate(inventoryItem: Partial<InventoryItem>, validateVendor = true): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!inventoryItem.itemId) {
    issues = [...issues, { message: 'Item is required', path: ['itemId'] }];
  }

  if (validateVendor && !inventoryItem.vendorId) {
    issues = [...issues, { message: 'Vendor is required', path: ['vendorId'] }];
  }

  if ((inventoryItem.quantityOrdered || 0) <= 0) {
    issues = [...issues, { message: 'Quantity ordered is required', path: ['quantityOrdered'] }];
  }

  if (!inventoryItem.costPerUnit) {
    issues = [...issues, { message: 'Cost per unit is required', path: ['costPerUnit'] }];
  }

  return { issues };
}